exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goto-action {\n  background-color: gray;\n  padding: 3px;\n  padding-left: 8px;\n  padding-right: 8px;\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 4px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/ai-chat-message/ai-chat-message-action/ai-chat-message-action.component.css
// module id = ../../../../../src/app/ai-chat/ai-chat-message/ai-chat-message-action/ai-chat-message-action.component.css
// module chunks = main